import {
  FLAG_ICON_MAP
} from "./chunk-7Z442QWJ.mjs";

// src/ActionButton/ActionButton.tsx
import { Button } from "@chakra-ui/react";
import { jsx } from "react/jsx-runtime";
var ActionButton = ({ flagKey, handleOnClick }) => {
  const FlagIcon = FLAG_ICON_MAP[flagKey];
  return /* @__PURE__ */ jsx(Button, {
    variant: "subtle",
    bg: "none",
    color: "font.primary",
    _hover: { md: { color: "primary.500" } },
    _focus: { bg: "none" },
    _active: { bg: "none" },
    border: "none",
    fontSize: "md",
    cursor: "pointer",
    fontWeight: "medium",
    onClick: handleOnClick,
    leftIcon: /* @__PURE__ */ jsx(FlagIcon, {
      boxSize: 6
    }),
    "data-testid": "languageSwitcherButton",
    children: flagKey.substring(0, 2).toUpperCase()
  });
};

export {
  ActionButton
};
